module.exports = __webpack_public_path__ + "img/1.98d4002a.png";